import { combineReducers } from '@ngrx/store';
import { currentReportIndex, currentReportTypeIndex, customPdfReportMenu, reportMenuFetchRequest, } from './report-menu/report-menu.reducers';
import { comparisonSecurities, primarySecurity, secondarySecurity, } from './report-securities/report-securities.reducers';
import { reportTitle, selectedReport } from './selected-report/selected-report.reducer';
import { currentWizardStepIndex } from './wizard-step/wizard-step.reducer';
import { brandingClientGroupId } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/branding-client-group/branding-client-group.reducers';
import { coverPageInfo, userPreferenceFetchRequest, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/cover-page/cover-page.reducers';
import { customTexts } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/custom-texts/custom-texts.reducer';
import { securityLevelValues } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/dollar-conversion-level-selector/dollar-conversion-level.reducer';
import { exportOption } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/export-option/export-option.reducers';
import { generateReportConfig, generatingSavedReport, generationErrors, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/generate/generate.reducers';
import { generateModalSelectedFolderableOperation } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/generate-modal-selected-folderable-operation/generate-modal-selected-folderable-operation.reducer';
import { hartfordCoverPageInfo } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/hartford-cover-page/hartford-cover-page.reducers';
import { namingConvention } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/naming-convention/naming-convention-reducer';
import { reportRegeneration } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/regeneration/regeneration.reducers';
import { riskProfile } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/risk-profile/risk-profile.reducer';
import { savedAnalysisPlanId } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/saved-analysis-plan-id/saved-analysis-plan-id.reducer';
import { compTableSecuritiesChoice, fundChartSecuritiesChoice, scatterPlotSecuritiesChoice, timeseriesTableSecuritiesChoice, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/saved-asset-securities-choices/saved-asset-securities-choices.reducer';
import { savedHypotheticalId } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/saved-hypothetical-id/saved-hypothetical-id.reducer';
import { sections } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/sections/sections.reducer';
import { talkingPoints } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/talking-points/talking-points.reducer';
import { transitionAnalyses } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/transition_analyses/transition-analyses.reducer';
export const CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY = 'customPdfReportModal';
export const customPdfReportModal = combineReducers({
    brandingClientGroupId,
    comparisonSecurities,
    coverPageInfo,
    currentReportIndex,
    currentReportTypeIndex,
    currentWizardStepIndex,
    customPdfReportMenu,
    exportOption,
    generatingSavedReport,
    generateReportConfig,
    generationErrors,
    hartfordCoverPageInfo,
    namingConvention,
    primarySecurity,
    reportMenuFetchRequest,
    reportTitle,
    riskProfile,
    savedHypotheticalId,
    savedAnalysisPlanId,
    secondarySecurity,
    sections,
    selectedReport,
    talkingPoints,
    customTexts,
    userPreferenceFetchRequest,
    reportRegeneration,
    fundChartSecuritiesChoice,
    scatterPlotSecuritiesChoice,
    compTableSecuritiesChoice,
    timeseriesTableSecuritiesChoice,
    securityLevelValues,
    transitionAnalyses,
    generateModalSelectedFolderableOperation,
});
